<template>
  <div class="connector-detail">
    <el-tabs v-model="activeName" class="md-tabs" @tab-click="handleClick">
      <el-tab-pane label="基本信息" name="basic" lazy>
        <basic-info></basic-info>
      </el-tab-pane>
      <el-tab-pane label="触发事件" name="trigger" lazy>
        <trigger-event></trigger-event>
      </el-tab-pane>
      <el-tab-pane label="执行动作" name="action" lazy>
        <do-action></do-action>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import BasicInfo from "./detail/basic-info.vue";
import DoAction from "./detail/do-action.vue";
import TriggerEvent from "./detail/trigger-event.vue";
export default {
  name: "connector-detail",
  props: {},
  data() {
    return {
      activeName: "basic",
    };
  },
  methods: { handleClick() {} },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      switch (from.path) {
        case "/create-trigger":
          vm.activeName = "trigger";
          break;
        case "/create-action":
          vm.activeName = "action";
          break;
        default:
          vm.activeName = "basic";
          break;
      }
    });
  },
  components: { BasicInfo, DoAction, TriggerEvent },
};
</script>
<style scoped lang="scss">
.connector-detail {
  display: flex;
}
</style>
